import { Injectable } from '@angular/core';

import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { RouteActionParam, routeActionParam } from 'src/app/infrastructure/services/page-services/models/return-page-query-param';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { IChatListData, chatListData } from '../models/chat-list-data';

// Navigatie naar de chatpagina. Die staat in de domaincontext (/domains/{dauGuid}/chats/{key}): een deelnemer van
// buiten het project heeft geen projectlidmaatschap. De dauGuid komt uit de rij (eigen DomainUser in het domain van
// de chat), zodat het centrale overzicht op Home chats uit elk domain kan openen. Nieuwe chat = dialoog, geen pagina.
@Injectable({
    providedIn: 'root'
})
export class ChatPageService
    extends _PageService
{
    constructor() {
        super(null);
    }

    override pageCreate_goto(): void {
        throw new Error('Chat create is a dialog, not a page');
    }

    override pageRoute_goto(item: IChatListData, keep?: RouteActionParam, routeParams?: {[key: string]: string}): void {
        this.pageChat_goto(item[chatListData.guid], item[chatListData.requestedDomainUser_guid], keep, routeParams);
    }

    pageChat_goto(chatGuid: string, dauGuid: string | null, keep?: RouteActionParam, routeParams?: {[key: string]: string}): void {
        const __dauGuid = dauGuid ?? this._activatedRouteService?.routeKeys?.dauGuid;
        this.page_goto(routePage.chat, {key: chatGuid, dauGuid: __dauGuid}, [keep ?? routeActionParam.none], routeParams);
    }
}
